import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getBetReport=({
    date,
    memberName,
    type
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.BET_REPORT_START,
    })
    const options={
        url:`${api}/bets/daily?userName=${memberName}&date=${date}&type=${type}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=> dispatch({
                type:actionTypes.BET_REPORT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.BET_REPORT_FAIL,
                payload:getMessage(error)
            }))
}